import { useCallback, useState } from 'react'
import { openGlobalModal } from '../../../store/reducers/globalModalSlice'
import { ClickAwayListener, styled } from '@mui/material'
import Popper from '@mui/material/Popper'
import Fade from '@mui/material/Fade'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { useAppDispatch } from '../../../hooks/redux'
import { FullReferralLinkDetails } from '../../../types/referralLinksTypes'
import { referralLinksServices } from '../../../services/referralLinksServices'
import { referralLinkActionCreators } from '../../../store/actionCreators/referralLinkActionCreators'

var fileDownload = require('js-file-download')

const StyledTableMenuButton = styled('div')({
	position: 'relative',
})

const StyledButton = styled(Button)(({ theme }) => ({
	whiteSpace: 'nowrap',
	color: '#3171D8',
	textTransform: 'initial',
	borderRadius: 0,
	'&:hover': {
		background: theme.palette.secondary.dark,
	},
}))

// type StyledMenuButtonProps = {
// 	indexRow: number
// }

const StyledMenuButton = styled('button')({
	display: 'flex',
	justifyContent: 'space-around',
	alignItems: 'center',
	width: '35px',
	height: '35px',
	padding: '5px',
	// backgroundColor: rowIndex % 2 ? '#EFF6FF' : '#FFFFFF',
	// backgroundColor: '#FFFFFF',
	borderRadius: '50%',
	border: 'none',
	'&:hover': {
		cursor: 'pointer',
	},
	div: {
		width: '4px',
		height: '4px',
		borderRadius: '50%',
		backgroundColor: '#3171D8',
	},
})

type RefLinkTableMenuButtonProps = {
	refLinkDetails: FullReferralLinkDetails
}

const RefLinkTableMenuButton = ({ refLinkDetails }: RefLinkTableMenuButtonProps) => {
	const dispatch = useAppDispatch()
	const [open, setOpen] = useState(false)
	const [arrowRef, setArrowRef] = useState<null | HTMLElement>(null)
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget)
		setOpen(previousOpen => !previousOpen)
	}

	const onClickAway = () => {
		setOpen(false)
		setAnchorEl(null)
	}

	const openEditRefLinkModal = useCallback(async () => {
		dispatch(referralLinkActionCreators.getRefLinkDetailsById(refLinkDetails.id))
			.unwrap()
			.then(() => dispatch(openGlobalModal({ variant: 'create-ref-link' })))
		// .catch(() => closeModal())
	}, [dispatch, refLinkDetails.id])

	const openDeleteRefLinkModal = useCallback(() => {
		dispatch(openGlobalModal({ variant: 'delete-ref-link', id: refLinkDetails.id }))
	}, [dispatch, refLinkDetails.id])

	const downloadRefLinkReportByIds = useCallback(async () => {
		const result = await referralLinksServices.downloadRefLinkReportByIds([
			refLinkDetails.id,
		])

		const file = await result.data
		const header = result.headers['content-disposition'] || ''
		const fileName = header.match(/filename=(.*);/) || []
		const test = fileName.length > 0 && fileName[1]

		await fileDownload(file, test)
	}, [refLinkDetails.id])

	return (
		<ClickAwayListener onClickAway={onClickAway}>
			<StyledTableMenuButton onClick={handleClick}>
				<>
					<StyledMenuButton className="btn-more">
						<div></div>
						<div></div>
						<div></div>
					</StyledMenuButton>

					<Popper
						sx={{ position: 'relative' }}
						open={open}
						anchorEl={anchorEl}
						disablePortal={true}
						placement="left-start"
						modifiers={[
							{
								name: 'arrow',
								enabled: true,
								options: {
									element: arrowRef,
								},
							},
						]}
						transition
					>
						{({ TransitionProps }) => (
							<>
								<Fade {...TransitionProps} timeout={350}>
									<Box
										sx={{
											marginRight: '10px',
											display: 'flex',
											flexDirection: 'column',
											border: '1px solid #3171D8',
											bgcolor: '#FFF',
										}}
									>
										<StyledButton variant="text" onClick={downloadRefLinkReportByIds}>
											Download CSV
										</StyledButton>
										<StyledButton variant="text" onClick={openEditRefLinkModal}>
											Edit
										</StyledButton>
										<StyledButton variant="text" onClick={openDeleteRefLinkModal}>
											Delete
										</StyledButton>
									</Box>
								</Fade>
							</>
						)}
					</Popper>
				</>
			</StyledTableMenuButton>
		</ClickAwayListener>
	)
}

export default RefLinkTableMenuButton
